module.exports = __webpack_public_path__ + "static/img/none.f44a6ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empty/none.png
// module id = tNGn
// module chunks = 12